import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { getLaunchDarklyClient } from './launch-darkly-client';

// Types

/**
 * Launch darkly plugin
 *
 * @param _
 * @param inject
 * @returns {Promise<void>}
 */
export var launchDarkly = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, inject) {
    var $cookies, anonUserId, client;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // Sync `anonUserId` between apps
          $cookies = context.$cookies;
          anonUserId = $cookies === null || $cookies === void 0 ? void 0 : $cookies.get('ld:$anonUserId');
          if (anonUserId) {
            localStorage.setItem('ld:$anonUserId', anonUserId);
          }
          // Init client only after syncing
          client = getLaunchDarklyClient();
          if (!(client === undefined)) {
            _context.next = 7;
            break;
          }
          inject('launchDarkly', {
            variation: function variation() {},
            track: function track() {},
            flush: function flush() {
              return new Promise(function (resolve) {
                resolve('');
              });
            },
            variationDetail: function variationDetail() {
              return {
                reason: null
              };
            }
          });
          return _context.abrupt("return");
        case 7:
          _context.next = 9;
          return client.waitUntilReady();
        case 9:
          inject('launchDarkly', client);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function launchDarkly(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export default launchDarkly;